// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__8IdZb","content":"NotFound_content__2F5h5","homeButton":"NotFound_homeButton__OwdWj"};